import TableColumn from "table/TableColumn";
import MultipleQueryColumn from "./MultipleQueryColumn";
import { ColumnType } from "./ColumnType";

/* The column heading, and it's type. */
export abstract class QueryColumn {

    public _basedOn?: TableColumn; // TODO: not public.
    protected _columnNumber: number = -1; // Number of column in the query from the left column. Sub-columns are also numbered from the top-level.
    public name: string;
    private _pixelWidth: number|null; // Can be used by complex columns if they are unexpanded.

    // _type and childColumns are mutually exclusive.
    _parent?: MultipleQueryColumn;
    // TODO _isCollection: boolean;

    constructor(basedOn?: TableColumn, parent?: MultipleQueryColumn) {
        this._basedOn = basedOn;
        this.name = basedOn?.name ?? "Unnamed";
        this._parent = parent;
        this._pixelWidth = null;
        //this._isCollection = false;
    }

    abstract canHaveChildren(): boolean;

    equals(c: QueryColumn): boolean {
        return this.name === c.name && this._parent === c._parent;
    }

    // If I am expanded, how many columns wide am I on the screen?
    columnsAcross(): number { 
        return 1;
    }

    // How many columns are below me.
    depth(): number {
        return 1;
    }

    numColumns() : number { 
        return 1;
    }

    abstract children() : QueryColumn[];

    abstract renumberColumnsImpl(from: number[]) : void;

    renumberColumns= () => {
        if (!this._parent) {
            // There should always be a parent, except for the root which overrides this method.
            throw new Error();
        }
        this._parent.renumberColumns();
    }

    get hasPixelWidth() : boolean {
        return null !== this._pixelWidth;
    }

    get pixelWidth () : number {
        if (null === this._pixelWidth) {
            return 100;
        }
        return this._pixelWidth;
    }

    set pixelWidth(width: number) {
        this._pixelWidth = Math.max(3, width);
    }

    /* Return an ID used for drag and drop. */
    get textualId() : string {
        if (!this._parent) {
            return "column_"+this.name;
        } else {
            return this._parent.textualId + "/" + this.name;
        }
    }

    get columns() : QueryColumn[] {
        return [];
    }

    public isTopLevel() {
        return this._parent?.type === ColumnType.RootColumn;
    }

    get parent() : MultipleQueryColumn {
        if (undefined !== this._parent) {
            return this._parent;
        } else {
            throw new Error();
        }
    }

    set parent(parent : MultipleQueryColumn) {
        this._parent = parent;
    }

    /* Number of the column in this query, numbered from the left-column
    * in the top-level query. Sub-columns are included in the numbering if they
    * are expanded */
    get columnNumber() : number {
        return this._columnNumber;
    }

    get type()  {
        return this._basedOn?.type ?? ColumnType.String;
    }

    get isCollection() {
        return this._basedOn?.collection ?? false;
    }

    public get isExpanded() : boolean { 
        return false;
    }
}
